module.exports = "/images/gy.svg?10680684c7d31360917c2ca4430587a9";